import { useMenuState } from '@szhsin/react-menu';
import cn from 'classnames';

import { OCCUPATION } from 'constants/user';
import i18n from 'i18n/config';
import Box from 'UIKit/Box';
import FilterDropDown from 'UIKit/FilterDropDown';

import { OccupationDropdownProps } from './ManadatoryDeclarationModal.types';
import styles from './mandatoryDeclarationModal.module.scss';
import SelectedLabel from './SelectedLabel';

const useroccupationLabel = i18n.t('account:whatIsYourOccupation');

const OccupationDropDown = ({
  selectedValue,
  errorMessage,
  onOccupationOptionClicked,
}: OccupationDropdownProps) => {
  const [menuState, toggleMenu] = useMenuState();

  const occupationOptions = OCCUPATION.map(userOccupation => ({
    label: <SelectedLabel optionId={userOccupation} selectedId={selectedValue} />,
    id: userOccupation,
    onClick: () => onOccupationOptionClicked(userOccupation),
    checked: selectedValue === userOccupation,
    dataTestId: userOccupation,
  }));

  return (
    <Box className={styles.occupationDropDownContainer}>
      <Box data-testid="useroccupationLabel" className={styles.dropDownLabel}>
        {useroccupationLabel}
      </Box>

      <FilterDropDown
        menuState={menuState}
        toggleMenu={toggleMenu}
        options={occupationOptions}
        label={selectedValue || ''}
        testId="occupation-dropdown"
        closeOnSelect
        className={styles.occupationDropDownContainer}
        styleOverrideClasses={{
          button: cn(styles.button, {
            [styles.buttonErrorHighlighted]: errorMessage,
          }),
          labelSection: cn({
            [styles.labelSectionWhenResidence]: selectedValue,
            [styles.labelSectionWhenNoResidence]: !selectedValue,
          }),
          label: styles.label,
          dropDown: styles.dropDown,
          optionLabel: styles.optionLabelClass,
        }}
        autoPosition
      />
    </Box>
  );
};

export default OccupationDropDown;
